export const ICON_HEIGHT = 120;
export const BAR_1 = 'bar-1';
export const BAR_2 = 'bar-2';
export const BAR_3 = 'bar-3';
export const PER_PAGE = 15;
export const MAX_LENGTH_TEXT_TABLE = 400;
export const DATE_FORMAT1 = 'dddd, DD MMMM, YYYY';
export const DATE_FORMAT2 = 'ddd, DD/MM/YYYY - HH:mm';
export const DATE_FORMAT3 = 'DD-MM-YYYY';
